<div class="product-item-two" (click)="_click()" style="background-image: url('{{produto.foto}}')">
  <div class="content"> 
    <h3>{{produto.nome}}</h3>
    <div class="footer">
      <div class="box">
          <a href="#" title="Compre Aqui" class="btn-compre">
            <span>COMPRE AQUI</span>
          </a>
        </div>
        <div class="box">
          <produto-item-valor classCustom="item-two" [servico]="produto" [valor]="produto.menor_tarifa"></produto-item-valor>
        </div>
    </div>
  </div>
  <span style="display:none;" itemprop="sku">{{produto.id}}</span> 
</div>

   